const headerData = {
    solutions: [
        {
            page: "solution",
            name: "Optimized Fiber-Optic Solution",
            image: "Optimized Fiber-Optic Solution",
            url: "/solution/optimized-fiber-optic-solution",
        },
        {
            page: "solution",
            name: "Fiber's Edge Over Copper",
            image: "Fibers Edge Over Copper",
            url: "/solution/fibers-edge-over-copper",
        },
        {
            page: "solution",
            name: "Scalable and Future Ready Design",
            image: "Scalable and Future-Ready Design",
            url: "/solution/scalable-and-future-ready-design",
        },
        {
            page: "solution",
            name: "Configurations and Personalized Support",
            image: "Configurations and Personalized Support",
            url: "/solution/configurations-and-personalized-support",
        },
    ],
    products: [
        {
            page: "product",
            type: "ONT",
            modelNum: "P4200R",
            // name: "ONT - P4200R",
            image: "ONT P4200r",
            url: "/product/ONT-P4200R",
        },
        // {
        //     page: "product",
        //     type: "ONT",
        //     modelNum: "G2410",
        //     // name: "ONT- G2410",
        //     image: "ONT g2410",
        //     url: "/product/ONT-G2410",
        // },

        {
            page: "product",
            type: "ONT",
            modelNum: "T2001",
            // name: "OLT -  SOLT33- 16P",
            image: "ONT T2001",
            url: "/product/ONT-T2001",
        },
        {
            page: "product",
            type: "OLT",
            modelNum: "SOLT33- 8P",
            // name: "OLT - SOLT33- 8P",
            image: "OLT SOLT33- 08P",
            url: "/product/OLT-SOLT33-8P",
        },
        // {
        //     page: "product",
        //     type: "OLT",
        //     modelNum: "SOLT33- 16P",
        //     // name: "OLT -  SOLT33- 16P",
        //     image: "OLT SOLT33-16P",
        //     url: "/product/OLT-SOLT33-16P",
        // },

        {
            page: "product",
            type: "OLT",
            modelNum: "MOLT - XGSPON 8P",
            // name: "OLT -  SOLT33- 16P",
            image: "OLT MOLT - XGSPON 8P",
            url: "/product/OLT-XGSPON-8P",
        },
        // {
        //     page: "product",
        //     type: "OLT",
        //     modelNum: "MOLT - XGSPON 16P",
        //     // name: "OLT -  SOLT33- 16P",
        //     image: "OLT MOLT - XGSPON 16P",
        //     url: "/product/OLT-XGSPON-16P",
        // },
    ],
    industries: [
        {
            page: "industries",
            name: "Hospitality",
            image: "HOSPITALITY",
            url: "/industries/hospitality-solutions",
        },
        {
            page: "industries",
            name: "Corporate Workspaces",
            image: "CORPORATE",
            url: "/industries/corporate-workspaces-solutions",
        },
        // {
        //     page: "industries",

        //     name: "Residential Real Estate",
        //     image: "Residential real estate",
        //     url: "/industries/residential-real-estate-solutions",
        // },
        {
            page: "industries",

            name: "Student Living",
            image: "Student living",
            url: "/industries/student-living-solutions",
        },
    ],
};

export default headerData;
